__webpack_require__.p = "https://assets.khanoumi.com/4.166.1.0/_next/";